'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _App = require('../ui/container/App');

var _App2 = _interopRequireDefault(_App);

var _privateRoute = require('./privateRoute');

var _privateRoute2 = _interopRequireDefault(_privateRoute);

var _enterIntercept = require('./enterIntercept');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Forbidden = function Forbidden(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/error/Forbidden').default);
    }, 'Forbidden');
};

var HomePage = function HomePage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/homeV2/HomePage').default);
    }, 'HomePage');
};
var SearchPage = function SearchPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/search/SearchPage').default);
    }, 'SearchPage');
};
var SubjectCUDetailPage = function SubjectCUDetailPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/subject/CUDetailPage').default);
    }, 'SubjectCUDetailPage');
};
var SubjectCUListPage = function SubjectCUListPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, (0, _privateRoute2.default)(require('../ui/container/subject/CUListPage').default));
    }, 'SubjectCUListPage');
};
var SubjectPage = function SubjectPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/subject/SubjectPage').default);
    }, 'SubjectPage');
};
var CUListPage = function CUListPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, (0, _privateRoute2.default)(require('../ui/container/cu/CUListPage').default));
    }, 'CUListPage');
};
var CUNewsPage = function CUNewsPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/cu/CUNewsPage').default);
    }, 'CUNewsPage');
};
var CUSubjectPage = function CUSubjectPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/cu/CUSubjectPage').default);
    }, 'CUSubjectPage');
};
var CUIntroPage = function CUIntroPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/cu/CUIntroPage').default);
    }, 'CUIntroPage');
};
var CUMajorHomePage = function CUMajorHomePage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/cumajor/CUMajorHomePage').default);
    }, 'CUMajorHomePage');
};
var CUMajorIntroPage = function CUMajorIntroPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, (0, _privateRoute2.default)(require('../ui/container/cumajor/CUMajorIntroPage').default));
    }, 'CUMajorIntroPage');
};
var MajorHomePage = function MajorHomePage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/major/MajorHomePage').default);
    }, 'MajorHomePage');
};
var MajorCUListPage = function MajorCUListPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, (0, _privateRoute2.default)(require('../ui/container/major/MajorCUListPage').default));
    }, 'MajorCUListPage');
};
var CUMajorTypesPage = function CUMajorTypesPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, (0, _privateRoute2.default)(require('../ui/container/major/CUMajorTypesPage').default));
    }, 'CUMajorTypesPage');
};
var CUMajorTypePage = function CUMajorTypePage(location, callback) {
    require.ensure([], function (require) {
        callback(null, (0, _privateRoute2.default)(require('../ui/container/major/CUMajorTypePage').default));
    }, 'CUMajorTypePage');
};
var RankHomePage = function RankHomePage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/rank/RankHomePage').default);
    }, 'RankHomePage');
};

var RankSubjectPage = function RankSubjectPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, (0, _privateRoute2.default)(require('../ui/container/rank/RankSubjectPage').default));
    }, 'RankSubjectPage');
};
var RankMajorPage = function RankMajorPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/rank/RankMajorPage').default);
    }, 'RankMajorPage');
};
var RankSchoolPage = function RankSchoolPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/rank/RankSchoolPage').default);
    }, 'RankSchoolPage');
};
var ArticlePage = function ArticlePage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/article/ArticlePage').default);
    }, 'ArticlePage');
};
var RankShuangyiPage = function RankShuangyiPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/rank/RankShuangyiPage').default);
    }, 'RankShuangyiPage');
};
var CareerListPage = function CareerListPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/career/CareerListPage').default);
    }, 'CareerListPage');
};
var TrinityListPage = function TrinityListPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/trinity/TrinityListPage').default);
    }, 'TrinityListPage');
};
var HiscoreYearPage = function HiscoreYearPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/hiscore/HiscoreYearPage').default);
    }, 'HiscoreYearPage');
};
var HiscoreMajorListPage = function HiscoreMajorListPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/hiscore/HiscoreMajorListPage').default);
    }, 'HiscoreMajorListPage');
};
var HiscoreMajorResultPage = function HiscoreMajorResultPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/container/hiscore/HiscoreMajorResultPage').default);
    }, 'HiscoreMajorResultPage');
};

var OverPaidPage = function OverPaidPage(location, callback) {
    require.ensure([], function (require) {
        callback(null, require('../ui/component/overPaid/OverPaidComponent').default);
    }, 'OverPaidPage');
};

exports.default = function () {
    return (
        // <Route path="/" name="app" component={App} onEnter={ navigator.appVersion.indexOf('Electron') === -1 ? enterIntercept : null }>
        _react2.default.createElement(
            _reactRouter.Route,
            { path: '/', name: 'app', component: _App2.default },
            _react2.default.createElement(_reactRouter.IndexRoute, { getComponent: HomePage }),
            _react2.default.createElement(
                _reactRouter.Route,
                { path: 'search' },
                _react2.default.createElement(_reactRouter.IndexRoute, { getComponent: SearchPage })
            ),
            _react2.default.createElement(
                _reactRouter.Route,
                { path: 'subject' },
                _react2.default.createElement(_reactRouter.IndexRoute, { getComponent: SubjectPage }),
                _react2.default.createElement(_reactRouter.Route, { path: 'cudetail/:cuHashId', getComponent: SubjectCUDetailPage }),
                _react2.default.createElement(_reactRouter.Route, { path: 'culist', getComponent: SubjectCUListPage })
            ),
            _react2.default.createElement(
                _reactRouter.Route,
                { path: 'cu' },
                _react2.default.createElement(_reactRouter.IndexRoute, { getComponent: CUListPage }),
                _react2.default.createElement(_reactRouter.Route, { path: 'news/:cuHashId', getComponent: CUNewsPage }),
                _react2.default.createElement(_reactRouter.Route, { path: 'intro/:cuHashId', getComponent: CUIntroPage }),
                _react2.default.createElement(_reactRouter.Route, { path: 'subject/:cuHashId', getComponent: CUSubjectPage })
            ),
            _react2.default.createElement(
                _reactRouter.Route,
                { path: 'cumajor' },
                _react2.default.createElement(_reactRouter.IndexRoute, { getComponent: CUMajorHomePage }),
                _react2.default.createElement(_reactRouter.Route, { path: 'intro/:majorHashId', getComponent: CUMajorIntroPage })
            ),
            _react2.default.createElement(
                _reactRouter.Route,
                { path: 'major' },
                _react2.default.createElement(_reactRouter.IndexRoute, { getComponent: MajorHomePage }),
                _react2.default.createElement(_reactRouter.Route, { path: 'culist', getComponent: MajorCUListPage }),
                _react2.default.createElement(_reactRouter.Route, { path: 'cumajor_types/:jobClassCode', getComponent: CUMajorTypesPage }),
                _react2.default.createElement(_reactRouter.Route, { path: 'cumajor_type/:majorTypeCode', getComponent: CUMajorTypePage })
            ),
            _react2.default.createElement(
                _reactRouter.Route,
                { path: 'rank' },
                _react2.default.createElement(_reactRouter.IndexRoute, { getComponent: RankHomePage }),
                _react2.default.createElement(_reactRouter.Route, { path: 'subject', getComponent: RankSubjectPage }),
                _react2.default.createElement(_reactRouter.Route, { path: 'major', getComponent: RankMajorPage }),
                _react2.default.createElement(_reactRouter.Route, { path: 'school', getComponent: RankSchoolPage }),
                _react2.default.createElement(_reactRouter.Route, { path: 'shuangyi', getComponent: RankShuangyiPage })
            ),
            _react2.default.createElement(_reactRouter.Route, { path: 'article/:categoryType/:typeId/:articleId', getComponent: ArticlePage }),
            _react2.default.createElement(
                _reactRouter.Route,
                { path: 'career' },
                _react2.default.createElement(_reactRouter.Route, { path: 'list/:categoryType/:typeId', getComponent: CareerListPage })
            ),
            _react2.default.createElement(
                _reactRouter.Route,
                { path: 'trinity' },
                _react2.default.createElement(_reactRouter.Route, { path: 'list/:typeId', getComponent: TrinityListPage })
            ),
            _react2.default.createElement(
                _reactRouter.Route,
                { path: 'hiscore' },
                _react2.default.createElement(_reactRouter.Route, { path: 'year', getComponent: HiscoreYearPage }),
                _react2.default.createElement(_reactRouter.Route, { path: 'major/list', getComponent: HiscoreMajorListPage }),
                _react2.default.createElement(_reactRouter.Route, { path: 'major/result/:majorHashId/:majorName', getComponent: HiscoreMajorResultPage })
            ),
            _react2.default.createElement(_reactRouter.Route, { path: '403', getComponent: Forbidden }),
            _react2.default.createElement(_reactRouter.Route, { path: 'overpaid', getComponent: OverPaidPage })
        )
    );
};


//////////////////
// WEBPACK FOOTER
// ./src/router/router.js
// module id = 506
// module chunks = 0